<div class="row">
  <div class="col-sm-12">
    <div class="termsAndConditions">
      {{creditlbl.termsAndConditionsPartOne?creditlbl.termsAndConditionsPartOne:creditReference.termsAndConditionsPartOne}}
    </div>
    <br />
    <div class="checkedButton center">
      <div class="form-group">
        <!-- <input type="checkbox" class="k-checkbox checkboxSize" id="termsConditions" [(ngModel)]="termsChecked"/>-->
        <!--[(ngModel)]="termsChecked"-->
        <kendo-switch [(ngModel)]="termsChecked" name="toggle" onLabel="Yes" offLabel="No" class=" ml-2">
        </kendo-switch>
        <!--[for]="termsConditions"-->
        <label class="lblCheck" for="termsConditions">
          {{creditlbl.acceptTermsLbl?creditlbl.acceptTermsLbl:creditReference.acceptTermsLbl}}
        </label>
      </div>
    </div>
    <form [formGroup]="creditReferenceForm">
      <!--*ngIf="termsChecked"-->
      <div *ngIf="termsChecked==true">
        <div class="row">
          <div class="col-lg-6 center">
            <div class="form-group">
              <label class="lbl" [for]="emailLbl">{{creditlbl.emailLbl?creditlbl.emailLbl:creditReference?.emailLbl}}<span class="requiredField">*</span> </label>
              <input type="text" kendoTextBox formControlName="email" #emailLbl class="kendoInput"
                     [ngClass]="{'borderRed':creditReference.isInvalidEmail}"
                     (blur)="validateCreditReferenceForm()" />
              <span title="{{creditlbl.invalidEmailLbl?creditlbl.invalidEmailLbl:creditReference.invalidEmailLbl}}" *ngIf="creditReference.isEmailFormatInValid" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfo"></span>
            </div>
            <div class="form-group">
              <label class="lbl" [for]="confirmEmailLbl">{{creditlbl.confirmEmailLbl?creditlbl.confirmEmailLbl:creditReference?.confirmEmailLbl}}<span class="requiredField">*</span> </label>
              <input type="text" kendoTextBox formControlName="confirmEmail" #confirmEmailLbl class="kendoInput"
                     [ngClass]="{'borderRed':creditReference.isInvalidConfirmEmail}"
                     (blur)="validateCreditReferenceForm()" />
              <span title="{{creditlbl.confirmEmailMatchLbl?creditlbl.confirmEmailMatchLbl:creditReference.confirmEmailMatchLbl}}" *ngIf="creditReference.emailNotMatched" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
            <div class="col-lg-12 middle">
              <button kendoButton class="m-3 clearKendoButton btn btn-success"
                      (click)="submitCreditReferenceRequest()"
                      [disabled]="requestInProcess">
                {{creditlbl.submitLbl?creditlbl.submitLbl:creditReference?.submitLbl}} <kendo-loader *ngIf="requestInProcess"
                                                                                                     style="color:blue"></kendo-loader>
              </button>
              <button kendoButton class="m-3 clearKendoButton btn btn-success"
                      [routerLink]="['/home']"
                      [disabled]="requestInProcess">
                {{creditlbl.cancelLbl?creditlbl.cancelLbl:creditReference.cancelLbl}}
              </button>

            </div>
          </div>
        </div>

      </div>
    </form>

  </div>

</div>
<section>
  <kendo-dialog [minWidth]="200" [minHeight]="125" title="{{creditlbl.creditConfirmTitleLbl?creditlbl.creditConfirmTitleLbl:creditReference.creditConfirmTitleLbl}}"
                *ngIf="creditReference.confirmDialogOpened" (close)="confirmDialogClose()">
    <div class="confirmationStyle">
      {{creditRefRequestInfoPopupLbl}}
      <br /> {{creditlbl.emailAddressAtRequestLbl?creditlbl.emailAddressAtRequestLbl:creditReference.emailAddressAtRequestLbl}}:
    </div>
    <div class="confirmationStyle">
      <strong>{{creditReference.emailText}}</strong>
    </div>
  </kendo-dialog>
</section>


